import { type ImgHTMLAttributes } from 'react';
import { type IconSize } from './ZepIcon';

/**
 * 재화(젤리) 아이콘. 기존 CoinColorV2Icon 을 대체한다.
 *
 * ZDS Foundation 의 Zelly 노드가 벡터가 아니라 raster(그라디언트 젤리)라
 * ZepIcon(SVG) 이 아닌 <img> 로 렌더한다. 그래서 `fill`(색 제어)은 지원하지 않고
 * 크기만 제어한다 — 색이 필요한 자리는 애초에 이 컬러 에셋을 쓴다.
 *
 * `size` 는 ZepIcon 과 같은 px 스케일로 맞춰 CoinColorV2Icon 과 1:1 로 교체된다.
 * className 의 크기 유틸(size-10 등)은 HTML width/height 속성보다 우선하므로
 * 기존 `className="size-10"` 식 호출도 그대로 동작한다.
 */
const SIZE_TO_PX: Record<IconSize, number> = {
  '2xs': 14,
  xs: 16,
  sm: 20,
  md: 24,
  lg: 28,
  xl: 32
};
interface JellyIconProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  size?: IconSize;
  /**
   * ZepIcon 자리에 그대로 꽂아 쓸 수 있게 fill 을 받되 무시한다(raster 라 색 제어 불가).
   * 메뉴/버튼처럼 아이콘에 fill 을 넘기는 공용 슬롯과 계약을 맞추기 위함.
   */
  fill?: string;
}
export const JellyIcon = ({
  size = 'md',
  fill: _fill,
  ...props
}: JellyIconProps) => {
  const dimension = SIZE_TO_PX[size];
  return <img src="/assets/jelly.webp" alt="" aria-hidden="true" width={dimension} height={dimension} {...props} data-sentry-component="JellyIcon" data-sentry-source-file="JellyIcon.tsx" />;
};